import {
  EditorComponent,
} from '@remirror/react';
import { cx } from '@trinity/chat-components';
import styles from './style/Editor.module.css';

type Props = {
  className?: string;
};

export const ProjectNotesEditor = ({
  className,
}: Props) => {

  return (
    <div className={cx(styles.root, className)}>
      <EditorComponent />
    </div>
  );
};